import { animate } from 'animejs';
import { refs, domReady } from '../modules/utils.js';

class LoopText extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#loopText();
  }

  #loopText() {
    animate(this.refs.bar, {
      translateX: '-50%',
      duration: 75000,
      ease: 'linear',
      loop: true,
    });
  }
}

customElements.define('loop-text', LoopText);
